// @flow
import { combineReducers } from 'redux';
import error from './error';
import gMapsError from './gMapsError';
import currentUser from './currentUser';
import userLocation from './userLocation';
import paymentMethods from './paymentMethods';
import invites from './invites';
import listingCounts from './listingCounts';
import areasOfFocus from './areasOfFocus';
import jobFunctions from './jobFunctions';
import internshipFunctions from './internshipFunctions';
import volopFunctions from './volopFunctions';
import orgs from './orgs';
import listings from './listings';
import groups from './groups';
import idealistDayEvents from './idealistDayEvents';
import mainSearch from './mainSearch';
import postSearch from './postSearch';
import modal from './modal';
import layout from './layout';
import searchRadius from './searchRadius';
import flashMessages from './flashMessages';
import userDashboard from './userDashboard';
import orgDashboard from './orgDashboard';
import groupDashboard from './groupDashboard';
import invoices from './invoices';
import pages from './pages';
import gradSchools from './gradSchools';
import daysMap from './daysMap';
import type { Action as ErrorAction } from '../actions/error';
import type { Action as GMapsErrorAction } from '../actions/gMapsError';
import type { Action as CurrentUserAction } from '../actions/currentUser';
import type { Action as UserLocationAction } from '../actions/userLocation';
import type { Action as PaymentMethodsAction } from '../actions/paymentMethods';
import type { Action as InvitesAction } from '../actions/invites';
import type { Action as ListingCountsAction } from '../actions/listingCounts';
import type { Action as AreasOfFocusAction } from '../actions/areasOfFocus';
import type { Action as JobFunctionsAction } from '../actions/jobFunctions';
import type { Action as InternshipFunctionsAction } from '../actions/internshipFunctions';
import type { Action as VolopFunctionsAction } from '../actions/volopFunctions';
import type { Action as OrgsAction } from '../actions/orgs';
import type { Action as ListingsAction } from '../actions/listings';
import type { Action as GroupsAction } from '../actions/groups';
import type { Action as IdealistDayEventsAction } from '../actions/idealistDayEvents';
import type { Action as MainSearchAction } from '../actions/mainSearch';
import type { Action as PostSearchAction } from '../actions/postSearch';
import type { Action as ModalAction } from '../actions/modal';
import type { Action as LayoutAction } from '../actions/layout';
import type { Action as SearchRadiusAction } from '../actions/searchRadius';
import type { Action as FlashMessagesAction } from '../actions/flashMessages';
import type { Action as UserDashboardAction } from '../actions/userDashboard';
import type { Action as OrgDashboardAction } from '../actions/orgDashboard';
import type { Action as GroupDashboardAction } from '../actions/groupDashboard';
import type { Action as InvoicesAction } from '../actions/invoices';
import type { Action as PagesAction } from '../actions/pages';
import type { Action as GradSchoolsAction } from '../actions/gradSchools';
import type { Action as DaysMapAction } from '../actions/daysMap';

type Action =
  | ErrorAction
  | GMapsErrorAction
  | CurrentUserAction
  | UserLocationAction
  | PaymentMethodsAction
  | InvitesAction
  | ListingCountsAction
  | AreasOfFocusAction
  | JobFunctionsAction
  | InternshipFunctionsAction
  | VolopFunctionsAction
  | OrgsAction
  | ListingsAction
  | GroupsAction
  | IdealistDayEventsAction
  | MainSearchAction
  | PostSearchAction
  | ModalAction
  | LayoutAction
  | SearchRadiusAction
  | FlashMessagesAction
  | UserDashboardAction
  | OrgDashboardAction
  | GroupDashboardAction
  | InvoicesAction
  | PagesAction
  | GradSchoolsAction
  | DaysMapAction;

const reducers = {
  error,
  gMapsError,
  currentUser,
  userLocation,
  paymentMethods,
  invites,
  listingCounts,
  areasOfFocus,
  jobFunctions,
  internshipFunctions,
  volopFunctions,
  orgs,
  listings,
  groups,
  idealistDayEvents,
  mainSearch,
  modal,
  layout,
  searchRadius,
  flashMessages,
  userDashboard,
  orgDashboard,
  groupDashboard,
  invoices,
  pages,
  postSearch,
  gradSchools,
  daysMap
};

export type Reducers = typeof reducers;
export default combineReducers<Reducers, Action>(reducers);
